import { shouldShowBuyOnce } from '../../models/buy-once'
import { widgetState } from '../../store/customizations/index'
import { buildElement } from '../../utils/element'

export const getSellingPlansMainElementWrapper = () => {
  const isPreviewClass = widgetState.customizations.isPreview && !widgetState.customizations.livePreview.show ? 'yotpo-is-preview' : ''
  const isAdminClass = widgetState.customizations.isReadOnly ? 'yotpo-admin-preview' : ''
  return buildElement('div', `yotpo-selling-plans-wrapper ${isAdminClass} ${isPreviewClass}`, {})
}

export const getSellingPlansMainElement = () => {
  return buildElement('div', 'yotpo-selling-plans', {})
}

export const appendElementsInOrder = (element: HTMLElement, sellingPlanGroups: HTMLElement[], buyOnceElement: HTMLElement): void => {
  if (!shouldShowBuyOnce()) {
    element.append(...sellingPlanGroups)
    return
  }
  if (widgetState.customizations.oneTimeAtLast) {
    element.append(...sellingPlanGroups, buyOnceElement)
    return
  }
  element.append(buyOnceElement, ...sellingPlanGroups)
}

export const getSelectedGroupIndex = (): number => {
  const autoPickOptionIndex = widgetState.customizations.autoPickOptionIndex
  return !shouldShowBuyOnce() && autoPickOptionIndex === 0 ? 1 : autoPickOptionIndex
}
